// @flow

import React from 'react';
import styled, { keyframes } from 'styled-components';
// import ring from './img/ring.svg';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const Ring = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #e74c3c;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${rotateAnimation} 0.8s linear infinite;
`;

const Loader = () => (
  <Wrapper>
    <Ring />
  </Wrapper>
);

export default Loader;
